import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    documentList: [],
    documentListCount: null,
    documentFilter: {
        main_filter: null,
        fields: {
            documentNumber: null,
            documentTitle: null,
            documentUserName: null,
            documentHash: null,
            documentClientId: null,
            documentCreatedAt: null,
            documentStatus: null,
            documentDeleted: null,
            documentCompanyId: null,
        },
    },
    documentModalOpen: false,
    document_id: null,
    document_index: null,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
